import React, { useState, useEffect, useRef } from 'react';
import { get_beneficiary_list_with_search, get_all_countries } from '../services/common';
import Beneficiary from './Customer/Beneficiary';
import Toast from '../Components/Toast/Toast';

const BeneficiaryList = () => {
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [beneficiaryId, setBeneficiaryId] = useState(null);
  const [showBeneficiaryModal, setShowBeneficiaryModal] = useState(false);
  const [countries, setCountries] = useState([]);
  const toastRef = useRef(null);
    const [search, setSearch] = useState('');
  useEffect(() => {
    const fetchBeneficiaryList = async () => {
      const response = await get_beneficiary_list_with_search(localStorage.getItem('systemToken'),search);
      setBeneficiaries(response.beneficiary);
      setLoading(false);
    };

    const fetchCountries = async () => {
      const response = await get_all_countries(localStorage.getItem('systemToken'));
      setCountries(response.data.countries);
    };

    fetchBeneficiaryList();
    fetchCountries();
  }, [search]);
 

  const viewBeneficiary = (id) => {
    setBeneficiaryId(id);
    setShowBeneficiaryModal(true);
  };

  return (
    <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto mt-4">
            <div className="bg-white rounded-lg shadow-sm">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
                <div className="flex items-center mt-2">
                <img src="/money-receive.svg" alt="Company Logo" className="mr-3" />
                <span className="font-medium lg:text-xl text-sm">My Beneficiary</span>
                </div>
            </div>
            <div className="mb-6">
                {/* Search bar */}
                <div className="flex items-center mb-4">
                    <input
                    type="text"
                    placeholder="Search beneficiary name here..."
                    className="bg-white w-1/3 pl-4 pr-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                {/* Table */}
                <div className="overflow-x-auto">
                    <table className="w-full border border-gray-300 rounded-lg shadow-sm">
                    <thead className="bg-gray-100">
                        <tr>
                        <th className="py-3 px-6 text-left border-b border-gray-300 w-[10%]">No</th>
                        <th className="py-3 px-6 text-left border-b border-gray-300 w-[40%]">Beneficiary Name</th>
                        <th className="py-3 px-6 text-left border-b border-gray-300 w-[25%]">Type</th>
                        <th className="py-3 px-6 text-center border-b border-gray-300 w-[25%]">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {beneficiaries.map((beneficiary, index) => (
                        <tr key={beneficiary.beneficiary_id} className="hover:bg-gray-50">
                            <td className="py-3 px-6 border-b border-gray-300">{index + 1}</td>
                            <td className="py-3 px-6 border-b border-gray-300">{beneficiary.beneficiary_name}</td>
                            <td className="py-3 px-6 border-b border-gray-300">
                            {beneficiary.beneficiary_type.toUpperCase()}
                            </td>
                            <td className="py-3 px-6 border-b border-gray-300 text-center">
                            <button
                                onClick={() => viewBeneficiary(beneficiary.beneficiary_id)}
                                className="text-blue-600 hover:text-blue-800 font-medium"
                            >
                                View
                            </button>
                            </td>
                        </tr>
                        ))}
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
      </div>
      <Beneficiary
        beneficiaryId={beneficiaryId}
        show={showBeneficiaryModal}
        onClose={() => setShowBeneficiaryModal(false)}
        countries={countries}
      />
      <Toast ref={toastRef} />
    </div>
  );
};

export default BeneficiaryList;